import React from 'react';

var _ = require('lodash');
var numeral = require('numeral');

function InvoiceStatic(data) {
    let invoice_static ={
        paid: 0,
        total_paid: 0,
        unpaid: 0,
        total_unpaid: 0,
        trial: 0,
        total_trial: 0,
        init: 0,
        total_init: 0,
        refund: 0,
        total_refund: 0,
        new: 0,
        total_new: 0,
        cancel: 0,
        total_cancel: 0,
    } 
    
    _.forEach(data, function(i) {
        if(i.status == "PAID") {
            invoice_static.paid = i.count_number;
            invoice_static.total_paid = i.total;
        }
        if(i.status == "UNPAID") {
            invoice_static.unpaid = i.count_number;
            invoice_static.total_unpaid = i.total;
        }
        if(i.status == "INIT") {
            invoice_static.init = i.count_number;
            invoice_static.total_init = i.total;
        }
        if(i.status == "TRIAL") {
            invoice_static.trial = i.count_number;
            invoice_static.total_trial = i.total;
        }
        if(i.status == "REFUND") {
            invoice_static.refund = i.count_number;
            invoice_static.total_refund = i.total;
        }
        if(i.status == "NEW") {
            invoice_static.new = i.count_number;
            invoice_static.total_new = i.total;
        }
        if(i.status == "CANCEL") {
            invoice_static.cancel = i.count_number;
            invoice_static.total_cancel = i.total;
        }
    })
    return invoice_static;
}

class InvoiceStatusSelect extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { onInvoiceStatusChange, invoice_static } = this.props;
    const invoice_static_data = InvoiceStatic(invoice_static);
    const styles = {
        color: "white",
        marginRight: 3,
        borderColor: 'transparent',
        borderRadius: "3px"
    }
    return(
        <React.Fragment>
            <button onClick={() => onInvoiceStatusChange("all")} style={styles} className="badge bg-indigo">Tất cả đơn hàng</button>
            <button onClick={() => onInvoiceStatusChange("new")} style={styles} className="badge badge-info">Đăng ký mới: {invoice_static_data.new} - {numeral(invoice_static_data.total_new).format("0,0")} đ</button>
            <button onClick={() => onInvoiceStatusChange("init")} style={styles} className="badge badge-warning">Chờ chấp nhận: {invoice_static_data.init} - {numeral(invoice_static_data.total_init).format("0,0")} đ</button>
            <button onClick={() => onInvoiceStatusChange("unpaid")} style={styles} className="badge badge-danger">Chờ thanh toán: {invoice_static_data.unpaid} - {numeral(invoice_static_data.total_unpaid).format("0,0")} đ</button>
            <button onClick={() => onInvoiceStatusChange("paid")} style={styles} className="badge badge-success">Đã thanh toán: {invoice_static_data.paid} - {numeral(invoice_static_data.total_paid).format("0,0")} đ</button>
            <button onClick={() => onInvoiceStatusChange("trial")} style={styles} className="badge bg-purple">Dùng thử: {invoice_static_data.trial} - {numeral(invoice_static_data.total_trial).format("0,0")} đ</button>
            <button onClick={() => onInvoiceStatusChange("cancel")} style={styles} className="badge badge-secondary">Đã huỷ: {invoice_static_data.cancel} - {numeral(invoice_static_data.total_cancel).format("0,0")} đ</button>
            <button onClick={() => onInvoiceStatusChange("refund")} style={styles}  className="badge bg-brown">Đã hoàn tiền: {invoice_static_data.refund} - {numeral(invoice_static_data.total_refund).format("0,0")} đ</button>
        </React.Fragment>
    )
  }
}


export default InvoiceStatusSelect;